// extracted by mini-css-extract-plugin
module.exports = {"root":"📦InlineError__root--v__9r","icon":"📦InlineError__icon--3HGwg","message":"📦InlineError__message--36n1d"};